// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './i18n/en';
import arTranslations from './i18n/ar';
import kuTranslations from './i18n/ku';
import deTranslations from './i18n/de';
import frTranslations from './i18n/fr';
import itTranslations from './i18n/it';
import spTranslations from './i18n/sp';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: enTranslations,
      ar: arTranslations,
      ku: kuTranslations,
      de: deTranslations,
      fr: frTranslations,
      it: itTranslations,
      sp: spTranslations
    },
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

// Sync document direction with detected language immediately on load
const RTL_LANGS = ['ar', 'ku'];
const applyDirection = (lng) => {
  const dir = RTL_LANGS.includes(lng) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lng);
  document.documentElement.style.direction = dir;
  localStorage.setItem('direction', dir);
};

// Listen for future language changes (including user-driven switches)
i18n.on('languageChanged', applyDirection);

// Apply immediately — covers synchronous init with LanguageDetector from localStorage
applyDirection(i18n.language || localStorage.getItem('i18nextLng') || 'en');

export default i18n;